import {Component, EventEmitter, Input, Output} from '@angular/core';

const LONG_LABEL_LIMIT: number = 5;

@Component({
  selector: 'scale-question',
  templateUrl: 'scale-question.html',
  styleUrls: ['scale-question.scss'],
})
export class ScaleQuestionComponent {

    @Input()
    public title: string;

    @Input()
    public description: string;

    @Input()
    public value: number = 0;

    @Input()
    public minLabel: string;

    @Input()
    public maxLabel: string;

    public readonly MAX_SCALE_STEPS: number = 100;

    @Input()
    public valueOnly: boolean = false;

    @Output()
    public valueChange: EventEmitter<string> = new EventEmitter<string>();

    public ngOnInit(): void {
      if (this.value !== 0) {
        this.value = this.MAX_SCALE_STEPS * this.value;
      }
    }

    public valueChanged(): void {
      this.valueChange.emit(`${this.value / this.MAX_SCALE_STEPS}`);
    }

    public get hasLongLabels(): boolean {
      return (this.minLabel && this.minLabel.length >= LONG_LABEL_LIMIT)
        || (this.maxLabel && this.maxLabel.length >= LONG_LABEL_LIMIT);
    }

    public get hasLabels(): boolean {
      return (this.minLabel && this.minLabel.length > 0)
        || (this.maxLabel && this.maxLabel.length > 0);
    }
}
